/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose, withHandlers, lifecycle } from 'recompose'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { withRouter } from 'react-router-dom'
import { analytics } from 'services/Analytics'
import { ALERTS } from 'constants/alerts'
import { ROUTES } from 'constants/routes'
import { withLocalization } from 'hocs/localization'
import { formWithCaptcha } from 'hocs/formWithCaptcha'
import { onShowError, createAlert } from 'redux-app/modules/alerts'
import { leaveEmail } from 'api/client/actions/auth'
import { isCaptchaEnabled, isCaptchaWhiteListed } from 'redux-app/selectors/apiData'
import { getSelectedPlanId } from 'redux-app/selectors/subscription'
import LeaveEmailForm from './LeaveEmailForm'

export default compose(
  connect(
    state => ({
      isCaptchaEnabled: isCaptchaEnabled(state),
      isCaptchaWhiteListed: isCaptchaWhiteListed(state),
      selectedPlanId: getSelectedPlanId(state),
    }),
    {
      leaveEmail,
      onShowError,
      createAlert,
    },
  ),
  withRouter,
  withHandlers({
    onSubmit: ({ leaveEmail, onShowError, createAlert, history, selectedPlanId }) => formValues => {
      return leaveEmail(selectedPlanId, formValues)
        .then(() => {
          createAlert({ name: ALERTS.successLeaveEmail })
          history.replace(ROUTES.home.home)
        })
        .catch(error => {
          onShowError(error)
        })
    },
  }),
  withLocalization('leaveEmail.form'),
  reduxForm({
    form: 'leaveEmail',
  }),
  formWithCaptcha,
  lifecycle({
    componentDidMount () {
      analytics.openLoginPage()
    },
  }),
)(LeaveEmailForm)
